/*!
 * @monogrid/vue-boost v8.0.1 Copyright (C) MONOGRID S.R.L. - All Rights Reserved - Unauthorized copying of this file, via any medium is strictly prohibited
 */
import { tryOnScopeDispose as p } from "@vueuse/core";
import { ref as d, reactive as v, watchEffect as w } from "vue";
const n = /* @__PURE__ */ new Map();
let o, f, i;
const u = () => {
  n.size > 0 ? !o && (o = window.requestAnimationFrame(y)) : (typeof o == "number" && window.cancelAnimationFrame(o), o = null, f = null);
}, y = (a) => {
  const s = Date.now();
  i = (f ? s - f : 0) / 1e3, i = Math.min(Math.max(i, 0), 0.5), f = s, n.forEach(({ fn: e, active: t, time: l }, c) => {
    t.value && (l.deltaTime = i, l.timestamp = a, typeof e == "function" && e(i, a));
  }), o = null, u();
}, A = (a, s = !1) => {
  const e = typeof a == "function" ? a : () => {
  }, t = d(s), l = v({ deltaTime: 0, timestamp: 0 }), c = (m) => t.value = m === void 0 ? !t.value : m, r = () => c(!1);
  return w(() => {
    t.value ? !n.get(e) && n.set(e, { fn: a, active: t, time: l }) : n.get(e) && n.delete(e), u();
  }), p(r), {
    time: l,
    active: t,
    dispose: r,
    toggle: c,
    activate: () => c(!0)
  };
};
export {
  A as default,
  A as useRAF
};
